import React from "react";

// importing styles
import "./home-page-styles.scss";

// importing sections
import HeaderSection from "../../sections/header-section/header-section";
import HeroSection from "../../sections/hero-section/hero-section";
import TagLineSection from "../../sections/tag-line-section/tag-line-section";
import WorkSection from "../../sections/work-section/work-section";
import AboutSection from "../../sections/about-section/about-section";
import ArticlesSection from "../../sections/articles-section/articles-section";
import AwardsSection from "../../sections/awards-section/awards-section";
import ContactSection from "../../sections/contact-section/contact-section";
import FooterSection from "../../sections/footer-section/footer-section";

const HomePage = () => {
	return (
		<>
			<HeaderSection />
			<HeroSection />
			<TagLineSection />
			<WorkSection />
			<AboutSection />
			<ArticlesSection />
			<AwardsSection />
			<ContactSection />
			<FooterSection />
		</>
	);
};

export default HomePage;
